import {
  Package, Layers, GitMerge, CheckSquare, AlertTriangle, BarChart2,
} from "lucide-react";

import {
  fetchInventoryDashboard,
  fetchInventoryBalance,
  fetchInventoryLedger,
  fetchInventoryAvailabilityById,
} from "../apis/inventory";

const TAB_DASHBOARD_CONFIG = {
  inventory: {
    title: "Inventory Dashboard",
    statsFetcher: fetchInventoryDashboard,
    stats: [
      { key: "total_products",      label: "Total Products",     Icon: Package,       color: "#2d75d3" },
      { key: "total_current_qty",   label: "Current Quantity",   Icon: Layers,        color: "#14915a" },
      { key: "total_allocated_qty", label: "Allocated Quantity", Icon: GitMerge,      color: "#5a45c1" },
      { key: "total_available_qty", label: "Available Quantity", Icon: CheckSquare,   color: "#0d9f61" },
      { key: "low_stock_count",     label: "Low Stock Items",    Icon: AlertTriangle, color: "#d97706" },
      { key: "total_allocations",   label: "Total Allocations",  Icon: BarChart2,     color: "#3b82f6" },
    ],
    subMenus: [
      {
        key: "balance",
        label: "Balance",
        fetcher: fetchInventoryBalance,
        columns: [
          { key: "product_name",  head: "Product" },
          { key: "current_qty",   head: "Current Qty" },
          { key: "allocated_qty", head: "Allocated Qty" },
          { key: "available_qty", head: "Available Qty" },
        ],
    
        rowDetailFetcher: (row) => fetchInventoryAvailabilityById(row.inventory_product_id),
        rowDetailConfig: {
          listKey: "allocations",
          listColumns: [
            { key: "sa_tran_no",    head: "SA Tran No" },
            { key: "wo_tran_id",    head: "Work Order" },
            { key: "allocated_qty", head: "Allocated Qty" },
            { key: "issued_qty",    head: "Issued Qty" },
            { key: "remaining_qty", head: "Remaining Qty" },
            { key: "status",        head: "Status" },
          ],
        },
      },
      {
        key: "ledger",
        label: "Ledger",
        fetcher: fetchInventoryLedger,
        columns: [
          { key: "tran_no",        head: "Tran No" },
          { key: "tran_type",      head: "Type" },
          { key: "movement_type",  head: "Movement" },
          { key: "tran_code",      head: "Code" },
          { key: "quantity",       head: "Qty" },
          { key: "balance_before", head: "Before" },
          { key: "balance_after",  head: "After" },
          { key: "ref_wo_tran_id", head: "Workorder No" },
          { key: "date", head: "Date", fmt: (v) => v ? new Date(v).toLocaleDateString() : "—" },
        ],
      },
    ],
  },
};

export default TAB_DASHBOARD_CONFIG;
